import { FulfillmentChannelOrderService } from 'common/data';
import { BaseStore } from 'core/stores';

class FulfillmentChannelOrderStore extends BaseStore {
	constructor(rootStore) {
		super(new FulfillmentChannelOrderService(rootStore.app.baasic.apiClient));
	}
}

export default FulfillmentChannelOrderStore;



// WEBPACK FOOTER //
// ./src/modules/fulfillment-channel-order/stores/FulfillmentChannelOrderStore.js